import gql from 'graphql-tag'

export const cashRegisterFragment = gql`
  fragment CashRegisterFragment on CashRegister {
    id,
    name,
    shopId
  }
`
